


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { applicationsDetail } from '@/permissions/index';

@Component({
  name: 'studentApplicationStatusComp'
})
export default class extends Vue {
  @Prop() private data!: any;

  get showApplicationsDetail() {
    return applicationsDetail() || true;
  }

  get year() {
    return UserModule.indexSelectYear;
  }

  public handleClick(data: any, routeName: string) {
    if (routeName === 'applicationList' && !this.showApplicationsDetail) {
      return;
    }
    const year = this.year === '0' ? '' : this.year;
    const stepId = data.stepId + '';
    this.$router.push({
      name: routeName,
      query: { stepId, year },
    })
  }
}
